import { render, staticRenderFns } from "./CumulativeCostTable.vue?vue&type=template&id=22305a10&scoped=true"
import script from "./CumulativeCostTable.vue?vue&type=script&lang=ts"
export * from "./CumulativeCostTable.vue?vue&type=script&lang=ts"
import style0 from "./CumulativeCostTable.vue?vue&type=style&index=0&id=22305a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22305a10",
  null
  
)

export default component.exports